/**
 * Requests a client makes in "My requests" (platform 'Client' in transactionhistory),
 * labelled for sellers and staff instead of the raw action name.
 * Copy and deletion of data never reach the seller bell (Admin only).
 */
const CLIENT_REQUEST_LABELS: Record<string, string> = {
  'Cancel Plan Requested':     'Client asked to cancel their plan (charges stopped)',
  'Cancel Product Requested':  'Client asked to cancel a service (charges stopped)',
  'Cancellation Withdrawn':    'Client reactivated their plan',
  'Data Copy Requested':       'Client asked for a copy of their data',
  'Data Correction Requested': 'Client asked to correct their data',
  'Data Deletion Requested':   'Client asked to delete their data',
};

/** Label for a client request, or null when the message is not one. */
export function clientRequestLabel(action: string, platform: string): string | null {
  return platform === 'Client' ? CLIENT_REQUEST_LABELS[action] ?? null : null;
}
